import * as React from 'react'
import { connectMenu, MenuExposed, MenuProvided } from 'react-instantsearch-core'

type IProps = MenuExposed & {
  hasFacets: boolean
  translations: {
    noResults: string,
    searchReset: string,
    blog_facet_select: {
      see_all_option: string,
    },
    searchBox: {
      placeholder: string,
    },
  },
}

interface IMenuItem {
  label: string
  value: string
  count?: number
  isRefined?: boolean
}

interface IState {
  hasFacets: boolean
}

class BlogFacetsMenu extends React.Component<IProps & MenuProvided, IState> {
  private domId: string

  constructor(props: BlogFacetsMenu['props'], context?: any) {
    super(props, context)

    this.state = {
      hasFacets: this.props.hasFacets,
    }

    this.domId = `blog_facet_${Math.floor(Math.random() * 10000)}`

    this.refine = this.refine.bind(this)
  }

  public componentDidUpdate(prevProps: IProps) {
    if (this.props.hasFacets !== prevProps.hasFacets) {
      this.setState({
        hasFacets: this.props.hasFacets,
      })
    }
  }

  public render() {
    const { currentRefinement, translations, items } = this.props
    return <div className="dropdown">
      <button
        className={
          'btn btn-outline-secondary btn-lg btn-block ' +
          'dropdown-toggle ' +
          `${this.optionsDisplayClass()}`
        }
        type="button"
        id={this.domId}
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span className="current-refinement">{currentRefinement || translations.blog_facet_select.see_all_option}</span>
      </button>
      <div
        className="dropdown-menu dropdown-menu-right rounded-0"
        aria-labelledby={this.domId}>
        <div className="blog-facets-wrapper">
          {items.map((item) => this.renderOption(item))}
        </div>
        {currentRefinement && this.renderShowAll()}
      </div>
    </div>
  }

  private refine(e: React.MouseEvent<any>, value: string) {
    e.preventDefault()

    this.props.refine(value)
  }

  private optionsDisplayClass() {
    if (this.state.hasFacets || this.props.currentRefinement) {
      return null
    }
    return 'disabled'
  }

  private renderOption(item: IMenuItem) {
    const props = {
      className: `dropdown-item ${item.isRefined ? 'active' : ''}`,
      onClick: (e: React.MouseEvent<any>) => !item.isRefined && this.refine(e, item.value),
    }

    return <button {...props} key={`blog-facet-option=${item.value}`}>
      <span className="refinement">{item.label}</span>
    </button>
  }

  private renderShowAll() {
    return <>
      <div className="dropdown-divider"></div>
      {this.renderOption({ value: '', label: 'All Posts' })}
    </>
  }
}

const ConnectedBlogFacetsMenu = connectMenu(BlogFacetsMenu)

const BlogFacets = (props: IProps) =>
  <ConnectedBlogFacetsMenu
    limit={100}
    transformItems={(items) => items.sort((a: any, b: any) => ByLabel(a, b))}
    {...props}
  />

const ByLabel = (a: any, b: any) => (
  a.label.toLowerCase().localeCompare(b.label.toLowerCase())
)

export { BlogFacets }
